<!-- <mat-form-field class="filter-field">
  <mat-label class="filter-font">Material filter</mat-label>
  <input matInput name="searchProject" (input)="applyFilterMaterial($event)" class="filter-text-spacer" />
  <usimweb-icon [icon]="'search'" matPrefix class="filter-icon"></usimweb-icon>
</mat-form-field> -->

<usimweb-input
  [fullWidth]="false"
  [placeholder]="'Material filter'"
  [icon]="true"
  (input)="applyFilterMaterial($event)"
></usimweb-input>

<usimweb-table
  [data]="dataTableSource"
  [columns]="curveColumns"
  [names]="columnNames"
  [filter]="filter"
  (clickedRow)="save($event)"
></usimweb-table>
